<template>
    <div>
        <triangle-image
            title="Manifesto"
            subtitle="Ecco i valori in cui crediamo e ai quali ci ispiriamo, dalla creazione delle nostre ricette al momento in cui assapori gusti autentici e sani">

        </triangle-image>

        <div class="container">
            <div class="content">

                <section class="section-how">
                    <div class="container-how">
                        <dl class="dl-horizontal">
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Crediamo che il buon cibo sia uno dei pilastri della buona salute. Un <b>cibo che nutre</b> è il primo passo per stare bene, per questo noi di Quomi sviluppiamo le nostre ricette a partire da ingredienti genuini e ti proponiamo una <b>dieta equilibrata e varia</b>, senza rinunciare a piatti gustosi e sfizi occasionali.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Vogliamo <b>riportare le persone in cucina partendo dagli ingredienti</b>: scegliamo prodotti non lavorati, freschi e di qualità, perché in cucina possiate vedere e conoscere i singoli ingredienti e scoprire la magia di trasformarli in piatti deliziosi.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Crediamo che cucinare <b>piatti gustosi</b> debba essere un’esperienza divertente e positiva, per questo le nostre ricette sono veloci, alla portata di tutti, e i risultati sono decisamente appetitosi.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd><b>Rispettiamo l’ambiente</b>, per questo lavoriamo con ingredienti stagionali, prevalentemente vegetali, non provenienti da allevamento intensivo o poco o per nulla trasformati industrialmente.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd><b>Crediamo che il cibo sia emozione e conoscenza</b>: i nostri piatti vogliono essere veicolo per viaggiare nella memoria della tradizione italiana, così come in luoghi esotici, alla (ri)scoperta di sapori e ingredienti nuovi e conosciuti.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Crediamo che la <b>dieta mediterranea</b> sia il modo più equilibrato di alimentarsi: molti vegetali, cereali e frutta, senza tuttavia rinunciare a carne, pesce e latticini. Proponiamo sempre menù vari, che non escludano nessun alimento.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Crediamo nel potere unico che ha il <b>cibo condiviso</b> di unire le persone: cucinare e mangiare insieme sono, infatti, gesti considerati parte integrante della dieta mediterranea intesa come stile di vita sano. Noi di Quomi desideriamo farti riscoprire il piacere di cucinare con e per le persone che ti sono vicine e dividere con loro i momenti trascorsi a tavola.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Crediamo che <b>mangiare sano</b> debba essere semplice e alla portata di tutti: per questo selezioniamo con attenzione ingredienti freschi, genuini e spesso artigianali. Li confezioniamo con cura e te li consegniamo garantendone la corretta conservazione fino a casa tua.<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Vogliamo aiutarti ad adottare uno <b>stile di vita sano</b>. Ci prendiamo cura di te creando ricette gustose e menù equilibrati, in modo che tu possa trascorrere il tempo risparmiato facendo ciò che ti rende felice - magari una bella passeggiata :)<br><br></dd>
                            <dt><i class="fa fa-heart fa-lg"></i></dt>
                            <dd>Siamo convinti che tutti voi siate speciali e meritiate il meglio, per questo lavoriamo continuamente per migliorare il servizio che vi offriamo. Studiamo, ricerchiamo e collaboriamo con persone che condividano i nostri valori, per portare sulle vostre tavole cibo sano e buono. Siamo spinti da una <b>grande passione per il cibo sano e per la natura</b> e non ci accontentiamo mai, ma puntiamo sempre all’<b>eccellenza</b>.</dd>
                        </dl>
                    </div>
                </section>

                <section class="section-how">
                   <div class="container-faq">
                        <i class="fa fa-question-circle fa-4x" aria-hidden="true"></i>
                        <br>
                        <h2 class="faq-title center">Come lo mettiamo in pratica</h2>
                        <p>Clicca qui per leggere <router-link :to="{name: 'suppliers'}" class="link-detail" title="Come costruiamo una migliore catena del cibo">come costruiamo una migliore catena del cibo</router-link></p>
                    </div>
                </section>

            </div>
        </div>

    </div>
</template>

<script>
import TriangleImage from '../components/TriangleImage'

export default {
	components: {
		'triangle-image': TriangleImage
	}

}

</script>

<style scoped>
.triangle-image {
    background-image: url("../assets/img/covers/values.jpg");
    background-position: center 0;
}

.section-how {
    max-width: 800px;
    margin: 0 auto;
}

.container-how dl {
  padding: 20px;
}
.dl-horizontal dd {
  margin-top: -3px;
  font-size: 15px;
  text-align: justify;
}
.dl-horizontal dt {
  margin-bottom: 10px;
  text-align: center;
}
.fa-heart {
  color: #f25f5c;
}
.section-team {
  background-color: #EDEDED;
}
.welcome-container {
  background-color: #ffffff;
}

.dl-horizontal dt {
  overflow: inherit;
  text-overflow: inherit;
}

h3.supplier-title-thumb {
  margin: 20px 0 5px 0;
}

.row.team {
  display: flex;
    flex-wrap: wrap;
}

.row.team > div {
  margin-bottom: 10px;
}

.container-faq {
    max-width: 768px;
    width: 100%;
    margin: 30px auto;
    text-align: center;
    position: relative;
    border: 1px solid #575A5C;
    border-radius: 6px;
    padding: 20px;
}

.container-faq .fa-question-circle {
  color: var(--quomi-primary);
  position: absolute;
  background-color: white;
  top: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 20px;
}

.faq-title {
    text-transform: uppercase;
    font-size: 15px;
}

dl {
 margin-top:0;
 margin-bottom:20px
}
dd,dt {
 line-height:1.42857143
}
dt {
 font-weight:700
}
dd {
 margin-left:0
}
@media (min-width:768px) {
 .dl-horizontal dt {
  float:left;
  width:21px;
  overflow:hidden;
  clear:left;
  text-align:right;
  text-overflow:ellipsis;
  white-space:nowrap
 }
 .dl-horizontal dd {
  margin-left:40px
 }
}

</style>
